import * as XLSX from 'xlsx';

const NOT_DATA_TEXT = '-';

export default class ManagersToTable {
  constructor(managers) {
    this.managers = managers;
  }

  toTable() {
    const headersRow0 = [
      'Фамилия, Имя менеджера',
      'Название компании',
      'Email',
      'Телефон',
      'ИНН',
      'Баланс тестов',
      'Кол-во кандидатов'
    ];

    const rows = this.managers.map((manager) => {
      manager.fullName = `${manager.last_name} ${manager.first_name}`;

      return [
        manager.fullName || NOT_DATA_TEXT,
        manager.customer?.company || NOT_DATA_TEXT,
        manager.email || NOT_DATA_TEXT,
        manager.phone || NOT_DATA_TEXT,
        manager.taxpayer_id_number || NOT_DATA_TEXT,
        manager.stock_balance,
        manager.candidates_count,
      ];
    });

    const data = [
      headersRow0,
      ...rows,
    ];

    const ws = XLSX.utils.aoa_to_sheet(data);
    // const merge = [
    //   { s: { r: 0, c: 9 }, e: { r: 0, c: 21 } },
    //   { s: { r: 0, c: 23 }, e: { r: 0, c: 25 } },
    //   { s: { r: 0, c: 26 }, e: { r: 0, c: 37 } },
    // ];
    // ws['!merges'] = merge;

    ws['!cols'] = [
      { wch: 30 }, // ширина первой колонки
      { wch: 30 }, // вторая колонка
      { wch: 25 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
      { wch: 20 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Менеджеры');

    XLSX.writeFile(wb, 'Менеджеры.xlsx');

    return this.managers;
  }
}
